import { render, staticRenderFns } from "./FlagListHorizontal.vue?vue&type=template&id=1a7600fc&scoped=true&"
import script from "./FlagListHorizontal.vue?vue&type=script&lang=js&"
export * from "./FlagListHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./FlagListHorizontal.vue?vue&type=style&index=0&id=1a7600fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7600fc",
  null
  
)

export default component.exports